module.exports = __webpack_public_path__ + "img/expandable_white.90d53172.svg";